<template>
  <div>
    <Header></Header>
    <div style="padding-top: 75px; background: #f3f5f9">
      <!-- 分类标签 -->
      <div class="tag-container container-xl">
        <div class="tag" :class="{ active: selectedTag == index }"
          v-for="(item, index) in categories" :key="index"
          @click="selectTag(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 1=>'真题',2=>'模拟',3练习(使用新接口),4每日一练(有单独接口) -->
      <!-- 功能板块 -->
      <div class="function-blocks container-xl xl-main">
        <div class="block green" @click="goToPage(1, categories[selectedTag].id)">
          <div class="block-title">真题考试</div>
          <div class="block-subtitle">历年真题试卷</div>
        </div>
        <div class="block blue" @click="goToPage(2, categories[selectedTag].id)">
          <div class="block-title">模拟考试</div>
          <div class="block-subtitle">模拟试卷测试</div>
        </div>
        <div class="block orange" @click="goToPage(3, categories[selectedTag].id)">
          <div class="block-title">章节练习</div>
          <div class="block-subtitle">专项练习</div>
        </div>
        <div class="block block-b light-orange" @click="goToPage(4, categories[selectedTag].id)">
          <div class="block-title">每日一练</div>
          <div class="block-subtitle">今日未完成</div>
        </div>
        <div class="block block-b pink" @click="goToPage(5, categories[selectedTag].id)">
          <div class="block-title">VIP试题</div>
          <div class="block-subtitle">购买课程 解锁试题</div>
        </div>
      </div>
      <!-- 学员记录列表 -->
      <!-- 做题记录列表 -->
      <div class="record-list container-xl flex">
      <div class="record-list-right">
          <h3 class="list-title">
            做题记录
            <div class="more" @click="goToPage(10,categories[selectedTag].id)">全部 <span class="iconfont icon-shuangjiantouyou"></span></div>
          </h3>

        <!--     <ul>
            <li v-for="(record, index) in records" :key="index">
              <div class="record-info">
                <div class="paper-title">{{ record.paper.title }}</div>
                <div class="record-meta">
                  <span>{{ record.end_at }}</span>
                  <span v-if="record.status === 1" class="text-red"
                    >未完成</span
                  >
                  <span v-if="record.status === 2"
                    >共{{ record.count }}道题，做对{{ record.right }}道</span
                  >
                </div>
              </div>
              <div class="action-btns">
                <button
                  v-if="record.status === 1"
                  class="btn btn-green"
                  @click="continueExam(record)"
                >
                  继续做题
                </button>
                <button
                  v-if="record.status === 2"
                  class="btn btn-blue"
                  @click="handlReport(record.id)"
                >
                  查看报告
                </button>
                <button
                  v-if="record.status === 2"
                  class="btn btn-green"
                  @click="handlAgain(record.paper_id)"
                >
                  再次练习
                </button>
              </div>
            </li>
          </ul> -->
          <RecordList :records="records"/>
        </div>

        <div class="record-list-left">
          <div class="report-catalog">
            <ul class="report-list">
              <li class="report-list-item "  @click="goToPage(8, categories[selectedTag].id)">
                <div class="flex items-center">
                  <i class="iconfont icon-cuoti"></i>
                  <span>我的错题</span>
                </div>
              </li>

              <li class="report-list-item " @click="goToPage(9, categories[selectedTag].id)">
                <div>
                  <i class="iconfont icon-shoucang1"></i>
                  <span>我的收藏</span>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/common/Header";
import Footer from "@/common/Footer";

import RecordList from "./exam/components/RecordList.vue"

import { getCategoryExam, getExamRecord } from "@/service/exam.js";

export default {
  components: {
    Header,
    Footer,
    RecordList
  },
  data() {
    return {
      categories: [],
      selectedTag: 0,
      records: [],
    };
  },
  created() {
    this.getCategoryExamFn();
    if(localStorage.getItem('token')){
      this.getExamRecordFn({
        page:1,
        per_page:3
      });
    }
  },
  methods: {

    async getExamRecordFn(params) {
      let res = await getExamRecord(params);
      if (res.code == 0) {
        this.records = res.data.data;
      }
    },
    // 分类
    async getCategoryExamFn() {
      let res = await getCategoryExam();
      console.log(res);
      if (res.code == 0) {
        this.categories = res.data;
      }
    },
    // 10做题记录
    goToPage(type, categoryId) {
      if (type == 1 || type == 2 || type == 3 || type == 8 || type == 9 ||  type == 10) {
        console.log(type);
        this.$router.push(
          `/questionBank/examList?type=${type}&categoryId=${categoryId}`
        );
      } else {
        this.$message.success("敬请期待");
      }
    },
    selectTag(index) {
      this.selectedTag = index;
    },
    goToAllRecords() {
      // 跳转全部记录页面逻辑
      console.log("查看全部记录");

    },
  },
};
</script>

<style lang="less" scoped>
.tag-container {
  padding-top: 30px;
  display: flex;
  margin-bottom: 20px;

  .tag {
    display: inline-block;
    padding: 12px 48px;
    border-radius: 4px;
    margin-right: 10px;
    cursor: pointer;
    color: #333;
  }
}

.tag.active {
  background-color: #42b983;
  color: white;
}

.function-blocks {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 20px;

  .block {
    width: 32%;
    height: 150px;
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
  }

  .block-b {
    width: 48%;
  }

  .green {
    background: linear-gradient(
      90deg,
      #4ddbae 0%,
      #3ddca4 37%,
      #25dc93 72%,
      #17de89 100%
    );
  }

  .blue {
    background: linear-gradient(
      90deg,
      #82c8fd 0%,
      #7dc2fc 37%,
      #75b7fb 72%,
      #6faefb 100%
    );
  }

  .orange {
    background: linear-gradient(
      90deg,
      #f5b475 0%,
      #f2a377 37%,
      #f19778 72%,
      #ef8c79 100%
    );
  }

  .light-orange {
    background-color: #facd91;
  }

  .pink {
    background-color: #f5bbba;
  }

  .block-title {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .block-subtitle {
    font-size: 14px;
  }
}

/* 做题记录 */
.record-list {
  border-radius: 4px;
  padding: 20px;
}

.list-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #666;
  padding:14px;
}

.more {
  color: #999;
  cursor: pointer;
}

.record-list ul {
  list-style: none;
  padding: 0 20px;
}

.record-list li {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record-info {
  flex: 1;
  margin-right: 20px;
}

.paper-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.record-meta {
  font-size: 14px;
  color: #666;
}

.text-red {
  color: #f44336;
  margin-left: 10px;
}

.action-btns {
  display: flex;
  align-items: center;
}

.btn {
  // padding: 6px 12px;
  border: none;
  // border-radius: 4px;
  cursor: pointer;

  background: #fff5eb;
  font-size: 14px;
  color: #ff8700;
  letter-spacing: 0;
  text-align: center;
  line-height: 16px;

  border-radius: 16px;
  height: 32px;
  padding: 0 20px;
}

.btn-green {
  background: linear-gradient(
    90deg,
    #51dbb1 0%,
    #45dca9 35%,
    #23dd91 74%,
    #17de89 100%
  );
  color: white;
}
.btn-green:hover {
  color: #107a4d;
}

.btn-blue {
  background: linear-gradient(
    90deg,
    #83c9fd 0%,
    #7ec3fc 35%,
    #73b5fb 74%,
    #70affb 100%
  );
  color: white;
  margin-right: 10px;
}
.btn-blue:hover {
  color: #1e80ff;
}
.record-list-right {
  flex-grow: 1;
  margin-right: 16px;
  background: white;
}
// ==
.record-list-left {
  width: 400px;
}
.report-catalog {
  background: #fff;
  padding: 7px 0;
}
.report-list-item{
  cursor: pointer;
}
// .report-list-item-content {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   height: 40px;
//   padding: 0 20px 0 8px;
//   border-radius: 6px;
//   cursor: pointer;
// }
// .report-list-item-content h5 {
//   font-weight: 400;
//   font-size: 14px;
//   color: #3c464f;
// }
// .report-list-item-content p {
//   font-weight: 600;
//   font-size: 18px;
//   color: #636e92;
// }
.content-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.record-list li:last-child {
  border: none;
}
// ==
.icon-cuoti{
  color:#23E196;
  font-size: 20px;
}
.icon-shoucang1{
  color:#FFC300;
  font-size: 24px;
}
.iconfont{
  margin-right: 10px;
}
</style>
